import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const DeleteButton = ({ onClickHandler }) => {
  return <RemoveCircleIcon style={{ color: '#D9D9D9', verticalAlign: 'middle', cursor: 'pointer', fontSize: '25px' }} onClick={onClickHandler} />;
};

export default DeleteButton;
